"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DEFAULT_FORMATS = ['webp', 'png'];
var getFormats = function (options) {
    return options.formats || DEFAULT_FORMATS;
};
exports.default = getFormats;
//# sourceMappingURL=getFormats.js.map